// /src/pages/dashboard/accounts/helpers.js
export function getPlatformIcon(platform) {
  switch (platform.toLowerCase()) {
    case 'facebook': return 'fab fa-facebook'
    case 'instagram': return 'fab fa-instagram'
    case 'x': return 'fab fa-twitter'
    case 'linkedin': return 'fab fa-linkedin'
    case 'threads': return 'fas fa-circle'
    case 'tiktok': return 'fab fa-tiktok'
    case 'pinterest': return 'fab fa-pinterest'
    case 'youtube': return 'fab fa-youtube'
    default: return 'fas fa-hashtag'
  }
}

export function getPlatformColor(platform) {
  switch (platform.toLowerCase()) {
    case 'facebook': return '#1877f2'
    case 'instagram': return '#E4405F'
    case 'x': return '#000000'
    case 'linkedin': return '#0077B5'
    case 'threads': return '#000000'
    case 'tiktok': return '#000000'
    case 'pinterest': return '#BD081C'
    case 'youtube': return '#FF0000'
    default: return '#888888'
  }
}
